module.exports = (__webpack_require__(2))(69);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/widgets/AccessWidget.js from dll-reference girder_lib
// module id = 23
// module chunks = 0